<template>
  <div>
    <wt-paged-table :on-request-data="getTableData" :total-size="totalNumber" :page-size="pageSize" v-loading="loading"
    ref="table" >
    <wt-table :list="tableData" :labels="tableLabels">
          <template>
            <slot/>
          </template>
      </wt-table>
    </wt-paged-table>
  </div>
</template>
<script>
export default {
  props: {
    tableLabels: {
      type: Array,
      default: function () {
        return []
      }
    },
    totalNumber: {
      type: Number,
      default: 0
    },
    tableData: {
      type: Array,
      default: function () {
        return []
      }
    },
    loading: {
      type: Boolean,
      default: false
    },
    pageSize: {
      type: Number,
      default: 10
    }
  },
  computed: {
    page () {
      return this.$refs.table.page
    }
  },
  methods: {
    getTableData (page, next) {
      this.$emit('getTableData', page, next)
    }
  }
}
</script>
<style module lang="less">

</style>
